import { useState } from 'react';
import { Typography } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import Input from 'components/new-ui/base/input/Input';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';
import { getRequiredMessage } from 'views/declarations/utils/validation-utils';

type Props = {
    open: boolean;
    templateName?: string;
    onCancel: () => void;
    onConfirm: (name: string) => void;
};

const DuplicateItemFieldTemplateModal = ({ open, templateName, onCancel, onConfirm }: Props) => {
    const [name, setName] = useState('');
    const [touched, setTouched] = useState(false);

    const trimmedName = name.trim();
    const nameError = touched && !trimmedName ? getRequiredMessage('templateName') : undefined;

    const reset = () => {
        setName('');
        setTouched(false);
    };

    const handleCancel = () => {
        reset();
        onCancel();
    };

    const handleConfirm = () => {
        reset();
        onConfirm(trimmedName);
    };

    return (
        <ConfirmationModal
            width={500}
            title="Duplicate template"
            confirmButtonText="Duplicate"
            icon={<CopyOutlined />}
            content={
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}>
                    <Typography.Text>Enter a name for the copy of "{templateName}".</Typography.Text>
                    <Input
                        placeholder="Enter Template Name"
                        status={nameError ? 'error' : undefined}
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                        onBlur={() => setTouched(true)}
                    />
                    {nameError && <div style={{ color: 'var(--error-normal)' }}>{nameError}</div>}
                </div>
            }
            confirmationButtonDisabled={!trimmedName}
            open={open}
            onCancel={handleCancel}
            onConfirm={handleConfirm}
        />
    );
};

export default DuplicateItemFieldTemplateModal;
